import styled from 'styled-components'

import type { StyledCssProps } from '@subaio/components'

import { inputStyles } from '../Shared'

export const InputComponent = styled.input<StyledCssProps<typeof inputStyles>>`
	${inputStyles}
`
